import axios from 'axios'
import config from "@/../config";

const state = {
  numeroRecibo: '',
  dataInicioEmissao: '',
  dataFimEmissao: ''
};

const stateExtrato = {
  segurado: null,
  vigencia_inicio: null,
  vigencia_fim: null,
  emissao_inicio: null,
  emissao_fim: null,
  modalidade: null,
  grupo_modalidade: null,
  id_grp_sub_limite: null,
  vigente: false,
};

const mutations = {
  SET_SEARCH_DATA(state, payload) {
    Object.keys(state).forEach(key => state[key] = payload[key])
  },

  SET_SEARCH_DATA_EXTRATO(state, payload) {
    Object.keys(stateExtrato).forEach(key => stateExtrato[key] = payload[key])
  },
};

const actions = {

  GET_TICKETS(commit, payload) {
    const searchData = { ...state }

    return axios.post(config.apiUrl + config.versoes[1] + '/recibos', searchData)
      .then(response => {
        return response.data
      })
      .catch(error => {
        return Promise.reject(error.response);
      })
  },

  GET_EXTRATOS(commit, payload) {
    const searchData = { ...stateExtrato }

    return axios.post(`${config.apiUrl}${config.versoes[0]}/corretor/${payload.document}/propostas`, searchData)
      .then(response => {
        return response.data
      })
      .catch(error => {
        return Promise.reject(error.response);
      });

    const data = [
      {
        nr_apolice: "1007507002412",
        nr_apolice_susep: "1007507006061",
        valor_is: 1000,
        premio: 360,
        comissao: 560,
        porcentagem_comissao: 1.13,
        dt_emissao: "2020-01-21",
        inicio_vigencia: "2020-01-21",
        fim_vigencia: "2021-01-21",
        tomador: "Vitor Cunha Cardoso",
        segurado: "Estevan Cavalcanti Oliveira",
        status: 'Emitida',
        cd_proposta: 210,
        cd_produto: 44,
      },
      {
        nr_apolice: "1007607000014",
        nr_apolice_susep: "1007607007895",
        valor_is: 900,
        premio: 360,
        comissao: 500,
        porcentagem_comissao: 1.01,
        dt_emissao: "2019-01-05",
        inicio_vigencia: "2019-01-05",
        fim_vigencia: "2021-12-05",
        tomador: "Fulano de Tal das Flores",
        segurado: "João Mirtão das Couves Neves",
        status: 'Emitida',
        cd_proposta: 2095,
        cd_produto: 8,
      },
      {
        nr_apolice: "1007607100089",
        nr_apolice_susep: "1057700007895",
        valor_is: 1900,
        premio: 360,
        comissao: 720,
        porcentagem_comissao: 1.44,
        dt_emissao: "2019-01-11",
        inicio_vigencia: "2019-01-11",
        fim_vigencia: "2022-01-11",
        tomador: "Felipe Barros Cavalcanti",
        segurado: "Julia Santos Fernandes",
        status: 'Emitida',
        cd_proposta: 2095,
        cd_produto: 8,
      },
    ]

    return data;

  },

  GET_PDF(state, payload) {
    return axios.post(config.apiUrl + config.versoes[1] + '/recibos/pdf', payload)
      .then(response => {
        return response.data ? response.data[0].base64 : '';
      })
      .catch(error => {
        return Promise.reject(error.response);
      })
  },

  GET_EXTRATO_XLS(state, payload) {
    return axios.post(config.apiUrl + config.versoes[1] + '/recibos/extrato/xls', payload)
      .then(response => {
        return response.data ? response.data[0].base64 : '';
      })
      .catch(error => {
        return Promise.reject(error.response);
      })
  }
};

export default { state, mutations, actions }


// WEBPACK FOOTER //
// ./src/store/modules/tickets.js